import React from 'react';

import SPBreadcrumb from 'components/base/SPBreadcrumb';
import SPSearchForm from 'components/product-price/car-model-price/search-form';
import SPTable from 'components/product-price/car-model-price/table';
import SPDrawer from 'components/product-price/car-model-price/drawer';
import SPModal from 'components/product-price/car-model-price/modal';
import SPPageActionBar from 'components/product-price/car-model-price/page-action-bar';
import SPCancelDrawer from 'components/product-price/cancel-rule-template/drawer';
import SPValueAddedDrawer from 'components/product-price/value-added-price/drawer';
import SPBookingRuleDrawer from 'components/product-price/booking-rule-template/drawer';
import SPVenhicleDrawer from '../../../components/carRental/vehicleManagement/SPVenhicleDrawer';
import SPServicePolicyDrawer from 'components/product-price/service-policy-template/drawer';
import SPContentWrap from "../../../components/carRental/base/SPContentWrap";

interface IPageProps {
	enums?: any;
	permission?: any;
}

const SPPage: React.FC<IPageProps> = props => {
	const { enums, permission } = props;
	return (
		<>
			<SPBreadcrumb title="车型商品定价" />
			<SPContentWrap className='common-margin-top'>
				<SPSearchForm enums={enums} />
			</SPContentWrap>
			<SPContentWrap className='page-action-bar'>
				<SPPageActionBar permission={permission}></SPPageActionBar>
			</SPContentWrap>
			<SPTable permission={permission} enums={enums} />
			<SPDrawer enums={enums} />
			<SPModal enums={enums}></SPModal>
			<SPCancelDrawer enums={enums}></SPCancelDrawer>
			<SPValueAddedDrawer enums={enums}></SPValueAddedDrawer>
			<SPBookingRuleDrawer enums={enums}></SPBookingRuleDrawer>
			<SPServicePolicyDrawer enums={enums}></SPServicePolicyDrawer>
			<SPVenhicleDrawer enums={enums} />
		</>
	);
};

export default SPPage;
